<script>
    export default {
        data() {
            return {
                firstLightboxActive: false,
                secondLightboxActive: false
            };
        },
        methods: {
            toggleFirstLightbox() {
                if (this.firstLightboxActive) {
                    this.firstLightboxActive = false;
                } else {
                    this.firstLightboxActive = true;
                    this.secondLightboxActive = false;
                }
            },
            toggleSecondLightbox() {
                if (this.secondLightboxActive) {
                    this.secondLightboxActive = false;
                } else {
                    this.secondLightboxActive = true;
                    this.firstLightboxActive = false;
                }
            },
            handleEscapePress(e) {
                if (e.key === 'Escape') {
                    this.firstLightboxActive = false;
                    this.secondLightboxActive = false;
                }
            }
        },
        mounted() {
            window.addEventListener('keyup', this.handleEscapePress);
        },
        beforeUnmount() {
            window.removeEventListener('keyup', this.handleEscapePress);
        }
    };
</script>